module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABJklEQVQ4T83UMUvDUBQF4HNjJ0H8B5J0EVx18RXBzeIqLrq4uzvYxjS8Ioh790K7dXdwESFPlO5ujRUcHYUS2lxJY0ONMaamQ9+WcPLlJDd5pEthEXgXORaD7siQgnMY0aUUNkItD8Y+bAoAXZbaBD76J9ZxTXU4hmBBMwriEcDWjNgzDancs53XEAKwdrmzsTQaKQCrWTFfo/1+xbkJ8hEUHBTr4oAZnWwQnbmmcz3JfoOCk4YUFQD1dIybrvlwMp35AX1hLQDHiRih62nD8tv50/ufUDjJ7S6BNmPYAIQ9t6ru4zdJbDQJGVJ8AFiO3gPjtHehGklNU6H1q9KK5+EW4CL7aLxY6tcPNxXKNr0wtYCQbosaabBmeYx4dvzTzm8bmVOjT99FVTowC9pyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/paixu/di.png
// module id = YsQQ
// module chunks = 3